<template>
    <div class="page_container">
        <div class="container_main">
            <!-- header  -->
            <div class="page_width theme_flex row hidden-xs" >
                <div class="logo md_logo " @click="toCategory('new')">
                    <img src="../assets/logo.jpg" alt="">
                </div>
                <!-- <img class="logo md_logo visible-sm" src="https://i.postimg.cc/XNT5mc2v/1683775300808-removebg-preview.png" alt="">
                <img class="logo visible-lg visible-md" src="https://i.postimg.cc/XNT5mc2v/1683775300808-removebg-preview.png" alt=""> -->
                <div class="header_menu row hidden-xs ">
                    <div class="header_menu_tab cursor" v-for="(v,index) in menu_list" :key="index" @click="toCategory(v)">  {{v}} </div>
                    <!-- <div class="header_menu_tab cursor" @click="showSearch">
                        <span class="content_icon" style="margin-right:10px;">
                            <svg t="1680250526186" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8477" data-darkreader-inline-fill="" width="20" height="20"><path d="M192 480a256 256 0 1 1 512 0 256 256 0 0 1-512 0m631.776 362.496l-143.2-143.168A318.464 318.464 0 0 0 768 480c0-176.736-143.264-320-320-320S128 303.264 128 480s143.264 320 320 320a318.016 318.016 0 0 0 184.16-58.592l146.336 146.368c12.512 12.48 32.768 12.48 45.28 0 12.48-12.512 12.48-32.768 0-45.28" fill="#020000" p-id="8478" data-darkreader-inline-fill="" style="--darkreader-inline-fill:#000000;"></path></svg>
                        </span>
                        search 
                    </div> -->
                <transition name="el-zoom-in-top" >
                   <div class="min_login hidden-xs" v-show="signIn_flag" >
                    <div class="inp_content">
                        <input type="text" class="inp_email default_inp" value='' placeholder="Email">
                        <input type="password" class="inp_pas default_inp" value='' placeholder="Password">
                        <button class="btu_sign tree_button default_btn" @click="toLogin">sign</button>
                        <span class="block_text">or</span>
                        <button class="btu_create tree_button default_btn" @click="toRegister">create an account</button>
                    </div>
                   </div>
                </transition>
            </div>
                <div class="nav_leave">
                    <div class="nav_tab" @click="signIn_flag = !signIn_flag">
                        <!-- <span class="nav_tapbar">SIGN IN</span> -->
                        <span class="content_icon ">
                           <!-- <svg t="1680234165226" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4947" data-darkreader-inline-fill="" width="20" height="20"><path d="M483.072 714.496l30.165333 30.208 415.957334-415.829333a42.837333 42.837333 0 0 0 0-60.288 42.538667 42.538667 0 0 0-60.330667-0.042667l-355.541333 355.413333-355.242667-355.413333a42.496 42.496 0 0 0-60.288 0 42.837333 42.837333 0 0 0-0.085333 60.330667l383.701333 383.872 1.706667 1.749333z" fill="#2c2c2c" p-id="4948" data-darkreader-inline-fill="" style="--darkreader-inline-fill:#000000;"></path></svg> -->
                           <svg t="1680250526186" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8477" data-darkreader-inline-fill="" width="20" height="20"><path d="M192 480a256 256 0 1 1 512 0 256 256 0 0 1-512 0m631.776 362.496l-143.2-143.168A318.464 318.464 0 0 0 768 480c0-176.736-143.264-320-320-320S128 303.264 128 480s143.264 320 320 320a318.016 318.016 0 0 0 184.16-58.592l146.336 146.368c12.512 12.48 32.768 12.48 45.28 0 12.48-12.512 12.48-32.768 0-45.28" fill="#020000" p-id="8478" data-darkreader-inline-fill="" style="--darkreader-inline-fill:#000000;"></path></svg> 
                        </span>
                    </div>
                    <div class="nav_tab" @click="visible_cart=!visible_cart">
                        <el-badge :value="quantity">
                        <span class="content_icon" >
                           <svg t="1680229423952" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2869" data-darkreader-inline-fill="" width="20" height="20"><path d="M716.8 307.2c0-113.1008-91.66848-204.8-204.8-204.8-113.1008 0-204.8 91.6992-204.8 204.8H102.4v546.14016C102.4 890.86976 133.13024 921.6 170.67008 921.6h682.65984C890.86976 921.6 921.6 890.86976 921.6 853.34016V307.2H716.8zM512 170.67008c75.42784 0 136.52992 61.1328 136.52992 136.52992H375.47008c0-75.39712 61.1328-136.52992 136.52992-136.52992z m341.32992 682.67008H170.67008V375.47008H307.2v136.54016h68.27008V375.47008h273.05984v136.54016H716.8V375.47008h136.52992v477.87008z" p-id="2870" fill="#020000" data-darkreader-inline-fill="" style="--darkreader-inline-fill:#000000;"></path></svg>
                        </span>
                    </el-badge>
                        <!-- <span class="nav_tapbar" style="margin-right:5px;">MY BAG</span>
                        <span class="">({{ quantity }})</span> -->
                    </div>
                </div>
            </div>
            <!-- header--mobile -->
             <div class="header_main theme_flex row header_mobile visible-xs" >              
                <img class="logo" src="../assets/logo.jpg" alt="" style='margin-top:15px;' @click="toCategory('new')">      
                <div class="nav_leave_mobile right_option">     
                    <div class="nav_tab cursor" @click="visible_cart=!visible_cart">
                        <svg t="1680229423952" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2869" data-darkreader-inline-fill="" width="20" height="20"><path d="M716.8 307.2c0-113.1008-91.66848-204.8-204.8-204.8-113.1008 0-204.8 91.6992-204.8 204.8H102.4v546.14016C102.4 890.86976 133.13024 921.6 170.67008 921.6h682.65984C890.86976 921.6 921.6 890.86976 921.6 853.34016V307.2H716.8zM512 170.67008c75.42784 0 136.52992 61.1328 136.52992 136.52992H375.47008c0-75.39712 61.1328-136.52992 136.52992-136.52992z m341.32992 682.67008H170.67008V375.47008H307.2v136.54016h68.27008V375.47008h273.05984v136.54016H716.8V375.47008h136.52992v477.87008z" p-id="2870" fill="#020000" data-darkreader-inline-fill="" style="--darkreader-inline-fill:#ffffe8;"></path></svg>      
                    </div>
                </div>
                 <div class="nav_leave_mobile left_option">     
                    <div class="nav_tab cursor"  @click="visible_menu=!visible_menu">
                       <svg t="1680249110711" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7010" data-darkreader-inline-fill="" width="20" height="20"><path d="M79.954 686.724h864.092v85.945h-864.092zM79.954 469.027h864.092v85.945h-864.092zM79.954 251.331h864.092v85.943h-864.092z" fill="#020000" p-id="7011" data-darkreader-inline-fill="" style="--darkreader-inline-fill:#ffffe8;"></path></svg>
                    </div>
                    <div class="nav_tab cursor " style="margin-left:15px;" @click="showSearch">
                       <svg t="1680250526186" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8477" data-darkreader-inline-fill="" width="20" height="20"><path d="M192 480a256 256 0 1 1 512 0 256 256 0 0 1-512 0m631.776 362.496l-143.2-143.168A318.464 318.464 0 0 0 768 480c0-176.736-143.264-320-320-320S128 303.264 128 480s143.264 320 320 320a318.016 318.016 0 0 0 184.16-58.592l146.336 146.368c12.512 12.48 32.768 12.48 45.28 0 12.48-12.512 12.48-32.768 0-45.28" fill="#020000" p-id="8478" data-darkreader-inline-fill="" style="--darkreader-inline-fill:#000000;"></path></svg>
                    </div>
                </div>
            </div>
            <!-- menu -->          
            <!-- search -->
            <div class="search_container page_container ">
                <div class="search_model"></div>
                <div class="search_content">
                    <input type="search" name="" v-model="search" placeholder="Search" class="search_inp default_btn" @keydown="ev_search($event)">
                    <span class="content_icon search_remove" @click="hideSearch">
                        <svg t="1682385763004" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10585" width="16" height="16"><path d="M576 512l277.333333 277.333333-64 64-277.333333-277.333333L234.666667 853.333333 170.666667 789.333333l277.333333-277.333333L170.666667 234.666667 234.666667 170.666667l277.333333 277.333333L789.333333 170.666667 853.333333 234.666667 576 512z" fill="#444444" p-id="10586"></path></svg>
                    </span>
                </div>
            </div>
            <!-- mobile menu -->
            <div class="header_menu_mobile visible-xs">
                <el-drawer 
                    size="50%"
                    title=""
                    :visible.sync="visible_menu"
                     direction="ltr"
                    :with-header="false">
                        <div class="drawer_header" @click="toLogin">
                            <div class="pull-left cursor"> <span class="mini_login glyphicon glyphicon-user"></span> sign in</div>
                        </div>
                        <div class="shop_top">
                            <img src="https://cdn.shopifycdn.net/s/files/1/2483/6632/files/NewTopMegamenu-Mobile_540x.jpg?v=1679974527" alt="">
                        </div>
                        <div class="header_menu_tab cursor" v-for="(v,index) in menu_list" :key="index" @click="toCategory(v)">  {{v}}  <span class="glyphicon glyphicon-menu-right"></span></div>
                </el-drawer>
            </div>
            <!-- cart drawer -->
            <div class="cart_drawer">
                <el-drawer
                    title=""
                    :size="sliderCartWidth"
                    :visible.sync="visible_cart"                
                    direction="rtl">        
                    <div class="slider_cart" v-if="goodsCart.length>0">
                        <div class="cart_theme" v-for="(v,index) in goodsCart" :key = 'index'>
                            <div class="theme_left">
                                <div class="cart_title">{{ v.name }}</div>
                                <div class="cart_option amount">${{ v.amount }}</div>
                                <div class="cart_option">
                                    <div class="cart_label">color:</div>{{ v.color_name }}
                                </div>
                                <div class="cart_option" style="text-transform: uppercase;">
                                    <div class="cart_label" >size:</div>{{ v.size }}
                                </div>
                                <div class="cart_option">
                                    <div class="quantity">
                                        <button class="quantity_change" @click="updateCount('cut',v,index)">-</button>
                                        <input class="quantity_number" type="number" :value="v.count">
                                        <button class="quantity_change" @click="updateCount('add',v,index)">+</button>
                                        <div class="cart_remove content_icon cursor" @click="updateCount('delete',v,index)">
                                           <svg t="1680591329878" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2816" data-darkreader-inline-fill="" width="16" height="16"><path d="M928.16 144H736V64a32 32 0 0 0-32-32H320a32 32 0 0 0-32 32v80H95.84a32 32 0 0 0 0 64H129.6l77.92 698.656A96 96 0 0 0 302.912 992h418.144a96.032 96.032 0 0 0 95.424-85.344L894.4 208h33.728a32 32 0 0 0 0.032-64zM352 96h320v48H352V96z m400.896 803.552a32 32 0 0 1-31.808 28.448H302.912a32 32 0 0 1-31.808-28.448L193.984 208h636.032l-77.12 691.552z" p-id="2817" fill="#231F20" data-darkreader-inline-fill="" style="--darkreader-inline-fill:#131210;"></path><path d="M608 820.928a32 32 0 0 0 32-32V319.104a32 32 0 0 0-64 0v469.824a32 32 0 0 0 32 32zM432 820.928a32 32 0 0 0 32-32V319.104a32 32 0 0 0-64 0v469.824a32 32 0 0 0 32 32z" p-id="2818" fill="#231F20" data-darkreader-inline-fill="" style="--darkreader-inline-fill:#131210;"></path></svg>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="cart_right ">
                               <img :src="v.image_urls[0]" alt="">
                            </div>
                        </div>
                        <div class="cart_totals">
                            <div class="pull-left cart_in_cart">({{ quantity }}) Items in bag</div>
                            <div class="pull-right cart_subtotal">
                                subtotal：
                                <span>${{ total }}</span>
                            </div>
                        </div>
                        <div class="cart_checkout">
                            <button class="tree_button btn_primary" @click="toCart">
                                begin checkout
                            </button>
                        </div>   
                    </div>
                    <div class="slider_cart_empty" v-else>
                        <div>Your cart is currently empty.</div>
                        <p>We've had a good look but there's nothing in here.</p>

                    </div>
                </el-drawer>     
            </div>
        </div>
    </div>
</template>

<script>
 import $ from 'jquery'
export default {
    name: 'ASTRHeader',
    inject:['reload'],
   
    data() {
        return {
            menu_list:['new','men','women'],
            visible_menu:false,
            visible_cart:false,
            clientWidth:document.body.clientWidth,
            sliderCartWidth:410,
            signIn_flag:false,
            search:'',
        
        };
    }, 

    mounted() {
       let that = this;
        window.onresize =() =>{
        return (()=>{
        window.clientWidth = document.body.clientWidth;
        that.clientWidth = window.clientWidth;
        if(that.clientWidth>768){
            that.sliderCartWidth = 410
        }
        if(that.clientWidth<=768){
            that.sliderCartWidth = 320
        }
        })()
       };
    },
    
    methods: {
        toCategory(path) {
            this.visible_menu = false
            if(path == 'new'){
             this.$router.push('/index')
              return
            }else{
              this.$router.push('/category?categoryName='+path)
              this.reload()
            }         
        },
        toCart(){
            this.visible_cart = false
            this.$store.commit('getGoods_cart_drawer',false)
            this.$router.push('/cart')
        },
        toLogin(){
            this.$router.push('/login')
        },
        toRegister() {
            this.$router.push('/register')
        },
        showSearch(){
         
            $('.search_container').css({'display': 'block','opacity':'1'})
            // $('.header_menu').css('display','none')
        },
        hideSearch(){
            $('.search_container').css({'display': 'none','opacity':'0'})
            $('.header_menu').css('display','flex')
        },    
        updateCount(type,item,index){
           this.$store.dispatch('updateItemCount',{type:type,item:item,index:index})
            
        },
        ev_search(ev){
            if(ev.keyCode == 13) {  //键盘回车的编码是13
                console.log('search',this.search)
                if(this.search){
                    this.hideSearch()
                    this.$router.push('/category?search='+this.search)
                    this.reload()
                }
            }
		},
      
        
   },
   computed: {
    goodsCart() { return this.$store.state.goods_cart},
    quantity(){return this.$store.state.goods_cart_count },
    total(){ return this.$store.state.goods_cart_total},
    // visible_cart(){ return this.$store.Goods_cart_drawer}
   },
   watch:{
    clientWidth(newVal,oldVal){
      if(newVal>768){
            this.sliderCartWidth = 410
        }
        if(newVal<=768){
            this.sliderCartWidth = 320
        }
    },
    // '$store.state.goods_cart_count':{
    //     deep: true,
    //     handler(nv,ov){
    //         this.quantity = nv
    //     }
    // },
    '$store.state.goods_cart_drawer':{
        deep: true,
        handler(nv,ov){
            this.visible_cart = nv
            let that = this
            setTimeout(() => {
                that.visible_cart = false
               that.$store.commit('setGoods_cart_drawer',false)
            }, 2000);
        }
    }

   }
};
</script>

<style lang="scss" scoped>
.logo{
    max-width: 100%;
    width:200px;
    // position: absolute;
    // left: 0;
    // margin: 0px auto 0;
    // right: 0;
    // width: 200px;
    // position: absolute;
    // top: 50%;
    // transform: translateY(-50%);
}
.md_logo{
    left: 30px;
    right: unset;
}
.header_mobile{
    // height:115px;
}
.theme_flex{
    justify-content: flex-start;
    align-items: center;
  .nav_leave{
    font-size:14px;
    height:115px;
    display: flex;
    align-items: center;
    justify-content: center;
    .nav_tab{
        padding-left:40px;
        display: flex;
        color:#666;
        font-weight:500;
        cursor: pointer;
      .nav_tapbar{
        margin:0 15px;
      }
    }
  }
}
.header_menu{
    position: relative;
    height:50px;
    font-size:14px;
    color:#666;
    flex:1;
    padding: 0 20px;
    // border-top:1px solid #dedede;
    // border-bottom:1px solid #dedede;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity .25s ease-in-out;
    .header_menu_tab{
        
        text-transform: uppercase;
        // letter-spacing: 1px;
        transition: all .25s;
        font-weight: 600;
        height:100%;
        line-height:50px;
        position: relative;
        display: flex;
        color:#000;
        font-size:14px;
        margin:0 16px;
        &::after{
            content:'';
			display:block;
			/*开始时候下划线的宽度为100%*/
			width:100%;
			height:2px;
			position:absolute;
			bottom:0px;
			background:#000;
			transition:all 0.3s ease-in-out;
			/*通过transform的缩放scale来让初始时x轴为0*/
			transform: scale3d(0,1,1);
			/*将坐标原点移到元素的中间，以原点为中心进行缩放*/
        }
        &:hover{
            &::after{
                /*鼠标经过时还原到正常比例*/
		    	transform:scale3d(1,1,1);
            }
        }
    }

    
}
.search_container{
    max-width:1300px;
    margin:0 auto;
    position: relative;
    height:50px;
    display: none;
    opacity: 0;
    .search_model{
        background:#fff;
        opacity: 0.7;
        z-index: 8;
        position: fixed;
        left:0;
        right:0;
        top:0;
        bottom:0;
    }
    .search_content{
        display: flex;
        z-index: 999;
        position: absolute;
        bottom:10px;
        left:0;
        right:0;
        transition: opacity .25s ease-in-out;
       
        .search_inp{
            flex:1;
            border-radius: 15px;
            background-color: #f4f4f4;
            border: 1px solid transparent;
            height:30px;
            transition: background-color .25s ease-in-out,border .25s ease-in-out;
            &:focus{
                background-color:#fff;
                border:1px solid #000;
                box-shadow: 0 0 0 1px #000;
               
            }
        }
        .search_remove{
            margin-left:20px;
            width:30px;
            height:30px;
            background-color:#f4f4f4;
            border-radius: 15px;
            line-height: 30px;
            border:1px solid transparent;
            &:hover{
                border:1px solid #000;
            }

        }
    }
}
.header_menu_mobile{
    .header_menu_tab{
        color:#000;
        padding: 0 20px;
        margin-bottom:40px;
        text-transform: uppercase;
        text-align: left;
        font-size:16px;
        letter-spacing: 1px;
        >span{
            font-size:14px;
            margin-left:10px;
        }
    }
    .shop_top{
        padding:20px;
        
    }
}
.drawer_header{
    padding:20px 20px 0;
    height:40px;
    font-size:12px;
    text-transform:uppercase;
    color:#000;
    .mini_login{
        font-size:14px;
        margin-right:5px;

    }
}
.cart_drawer{
    .slider_cart{
        padding:20px;
        .cart_theme{
            display: flex;
            line-height:1.5;
            .theme_left{
                flex:1;
                margin-left:20px;
                 color:#000;
                 text-align: left;
                .cart_title{
                    font-size:14px;
                    text-transform: uppercase;
                    letter-spacing:1px;
                    transform: scale(0.8);
                    transform-origin: 0 0;
                }
                .cart_option{
                    font-size:10px;
                    display: flex;
                    transform: scale(0.8);
                    transform-origin: 0 0;
                    margin:3px 0;
                    .cart_label{
                        font-weight: 600;
                        text-transform: uppercase;
                        margin-right:5px;

                    }
                }
            }
            .cart_right{
                width:70px;
                >img{
                    width:100%;
                    height:auto;
                }
            }
            .cart_remove{
                margin-left:20px;
            }
        }
        .cart_totals{
            clear: both;
            overflow: hidden;
            color:#000;
            margin-top:30px;
            padding:10px 0;
            border-top:1px solid #979797;
            border-bottom:1px solid #979797;
            .cart_in_cart{
                text-decoration: underline;
                padding-left:10px;

            }
            .cart_subtotal{
                padding-right:10px;
                text-transform: uppercase;
                font-weight: 600;
                >span{
                    min-width:60px;
                    margin-left:10px;

                }
            }
        }
        .cart_checkout{
            width:100%;
            margin-top:20px;
        }
    }
    .slider_cart_empty{
        padding:20px;     
        letter-spacing: 1.5px;
        >div{
            font-size:18px;
        }
    }
}
.min_login{
    height:80px;
    position:absolute;
    bottom:-81px;
    left:0%;
    right:0%;
    z-index:99;
    background-color:#fff;
    .inp_content{
        display: flex;
        justify-content: center;
        align-items: center;
        width:80%;
        margin-left:10%;
        margin-right:10%;
        margin-top:20px;
        font-size:16px;
        .block_text{
            margin:0 10px;

        }
    }
}
// element-ui drawer
/deep/ .el-drawer__header{
    margin-bottom:0;
}


</style>


// WEBPACK FOOTER //
// src/components/header.vue